'use client'

import dynamic from 'next/dynamic'
import { ReactNode } from 'react'

import FirstView from '@/components/About/Molecules/FirstView'
import IndexContent from '@/components/About/Organisms/IndexContent'
import '@/components/Page/About/AboutPage.scss'

type Props = {
  productElm: ReactNode
  journalElm: ReactNode
}

const AboutPageLogic = dynamic(() => import('@/components/Page/About/AboutPageLogic'), {
  ssr: true,
})

export default function AboutPage({ productElm, journalElm }: Props) {
  return (
    <AboutPageLogic productElm={productElm} journalElm={journalElm}>
      <div className="p-about">
        <FirstView />
        <IndexContent />
      </div>
    </AboutPageLogic>
  )
}
